import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import PageResetPassword from '@pages/reset-password/ui/PageResetPassword';

export const Route = createFileRoute('/_guest/reset_password')({
  component: PageResetPassword,
});
